import extendAvailabilityModel from './extendAvailabilityModel';
import extendShiftModel from './extendShiftModel';
import extendLeaveModel from './extendLeaveModel';
import extendDayMarkModel from './extendDayMarkModel';
import context from '../context';
import isAbsenceEvent from '../helpers/isAbsenceEvent';
import { SHIFT_TYPE, UNAVAILABILITY_TYPE, DAY_MARK_TYPES } from '../constants';

export default function extendCalendarModel(
  calendar,
  displayMode,
  days = [],
  { mutate = false, nowDate, calendarDisplayOptimize = false } = {}
) {
  const result = mutate ? calendar : { ...calendar };

  if (result.type === SHIFT_TYPE || isAbsenceEvent(result)) {
    return extendShiftModel(result, { mutate, nowDate, calendarDisplayOptimize });
  }

  if (context.isTimeOff(result.type)) {
    return extendLeaveModel(result, displayMode, days);
  }

  if (DAY_MARK_TYPES.includes(result.type)) {
    return extendDayMarkModel(result);
  }

  if (result.type === UNAVAILABILITY_TYPE) {
    return extendAvailabilityModel(result);
  }

  return result;
}
